import React from "react";
import BOOKING from "../../assets/images/booking.png";
import LOWPRICE from "../../assets/images/low-price.png";
import EXISTINGDEAL from "../../assets/images/exting-deal.png";
import SUPPORT from "../../assets/images/support.png";
import BookCard from "./BookCard";

const bookingFeatures = [
  {
    title: "Lowest Price",
    image: LOWPRICE,
    description:
      "We take pride in offering a lowest fare guarantee that often surpasses online portal rates.",
  },
  {
    title: "Exciting Deals",
    image: EXISTINGDEAL,
    description:
      "Enjoy exciting deals on flights, hotels, buses, car rental and tour packages.",
  },
  {
    title: "24/7 Support",
    image: SUPPORT,
    description:
      "Our dedicated customer service team is available 24/7 to assist with any inquiries, changes, or special requests.",
  },
  {
    title: "Easy Booking",
    image: BOOKING,
    description:
      "Big Smile Holidays is committed to providing a superior air ticket booking experience that goes beyond what typical online portals offer.",
  },
];

const BookSection = () => {
  return (
    <div className="book-section mb-4">
      <div className="container">
        <h2>Why book with us?</h2>
        <div className="row">
          {bookingFeatures.map((feature, index) => (
            <div key={index} className="col-md-3 col-sm-6">
              <BookCard feature={feature} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookSection;
